import { NodeType } from '@vedalib/editor'

import { DeviceMode } from 'services/Store/Project/enums'

export const MIN_WIDTH_LIMIT = 0

export const DEVICE_DESK_ORDER: DeviceMode[] = [
  DeviceMode.desktop,
  DeviceMode.tablet,
  DeviceMode.mobile,
]

export const DEVICE_ASK_ORDER: DeviceMode[] = [
  DeviceMode.mobile,
  DeviceMode.tablet,
  DeviceMode.desktop,
]

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DEFAULT_NODE: { [key in NodeType]: { [key: string]: any } } = {
  [NodeType.row]: {
    style: {
      flexGrow: 0,
    },
  },
  [NodeType.column]: {
    style: {
      flexBasis: 0,
      display: 'flex',
    },
  },
  [NodeType.shell]: {
    grow: false,
    widthType: 'auto',
    heightType: 'auto',
  },
  [NodeType.absolute]: {
    style: {
      zIndex: 0,
    },
  },
  [NodeType.node]: {
    style: {
      width: 'auto',
      height: 'auto',
    },
  },
}

export const SHELL_SIZE_KEYS = ['maxWidth', 'maxHeight', 'minWidth', 'minHeight', 'width', 'height']
